var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepBox"},[_c('div',{staticClass:"step"},[_c('qiangzhi',{ref:"qiangzhijieguoRef"}),_c('qiangzhiForm')],1),_c('fengxian',{attrs:{"type":2}}),_c('fuwu',{attrs:{"type":2}}),_c('mElectronicFooter',{attrs:{"disabledNext":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }